import {
  ConfigurationPanelStructureItemEnum, ElementPartTypeEnum, FieldConfig, TemplateParentTypeEnum, TemplateStructureEnum, WidgetTypeConfig,
} from '@/types';
// V3
// eslint-disable-next-line import/no-cycle
import emailSpacerFieldsConfig from '@/components/template-builder/config/templates/email/widgets/widget-spacer-fields-config';
// V4
// eslint-disable-next-line import/no-cycle
import emailSpacerFieldsConfigV4 from '@/components/template-builder/config/templates/email-v4/widgets/widget-spacer-fields-config';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';
// eslint-disable-next-line import/no-cycle
import { isEmailTemplate } from '../../utils/helpers';

const getWidgetSpacerConfig = (templateType: TemplateParentTypeEnum, isV4 = false): WidgetTypeConfig => {
  const fieldItems: Array<FieldConfig> = isV4 ? emailSpacerFieldsConfigV4 : emailSpacerFieldsConfig;
  const paddingSelector = isEmailTemplate(templateType) ? '{SELECTOR} > tbody > tr > th' : '{SELECTOR}';

  return {
    tabPanel: {
      label: 'templateBuilder.widgetsHeaders.spacer',
      items: [
        {
          type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
          tabItemType: TemplateStructureEnum.GROUP,
          label: 'templateBuilder.configs.widgetStyles',
          canSave: true,
          elementPartType: ElementPartTypeEnum.STYLES,
          tabPanel: {
            items: [
              {
                type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
                label: 'templateBuilder.configs.widgetBlockStyles',
                selector: 'body #spm_body #{ID}',
                items: fieldItems,
              },
              getWidgetCommonStylesGroup(paddingSelector),
            ],
          },
        },
        getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
      ],
    },
  };
};

export default getWidgetSpacerConfig;
